import { render, staticRenderFns } from "./CollectionTransactionHistoryComponent.vue?vue&type=template&id=ebeb8332&"
import script from "./CollectionTransactionHistoryComponent.vue?vue&type=script&lang=js&"
export * from "./CollectionTransactionHistoryComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports